module.exports = __webpack_public_path__ + "img/vnd.google-apps.document.71750a6e.svg";